/**
 * @generated SignedSource<<18749a07a4a50cdfa8e5fe752724c429>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapSidebar_sidebar",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSections_page"
    }
  ],
  "type": "ResourceWithSections",
  "abstractKey": "__isResourceWithSections"
};

node.hash = "faee91274af60938581c650a0946cf8a";

module.exports = node;
